/**
 * Default width for candidate cards in the Kanban board
 * Used to ensure consistent card sizing across all columns
 */
export const CARD_WIDTH = '280px'

/**
 * Stage IDs used throughout the application
 */
export const STAGE_IDS = {
	REJECTED: 'rejected',
	HIRED: 'hired',
} as const

/**
 * Drag and drop data types
 * Used to identify what kind of element is being dragged
 */
export const DRAG_TYPES = {
	CANDIDATE: 'candidate',
	COLUMN: 'column',
} as const

/**
 * Default pipeline stages for organisations that haven't configured custom defaults
 */
export const DEFAULT_PIPELINE_STAGES = [
	{ id: 'new', name: 'New', locked: true },
	{ id: 'call', name: 'Call', locked: false },
	{ id: 'interview', name: 'Interview', locked: false },
	{ id: 'offer', name: 'Offer', locked: false },
	{ id: 'hired', name: 'Hired', locked: true },
	{ id: 'rejected', name: 'Rejected', locked: true },
] as const

export type DefaultPipelineStage = (typeof DEFAULT_PIPELINE_STAGES)[number]
